/**
 * `Н48` (баг РП, 16.10 17:3x): отказ сервера по вводу показывается **у поля**.
 *
 * Сервер отвечает на негодный ввод 400 с перечнем `errors`: `{ field, message,
 * location }` — без самого отправленного значения (`АУД-Н159`). Прежде форма
 * администратора показывала одно общее «Ошибка при сохранении пользователя», и
 * человек не знал, какое поле править.
 *
 * Помощник один на формы: разбирает и перечень полей, и общее сообщение — что
 * найдётся, то и назовём.
 */

export type FieldErrors = Record<string, string>;

/** Причины по полям из ответа сервера; пусто — если их там нет. */
export function fieldErrorsFrom(error: unknown): FieldErrors {
  const errors = (error as any)?.response?.data?.errors;

  if (!Array.isArray(errors)) return {};

  const byField: FieldErrors = {};

  for (const point of errors) {
    const field = point?.field;
    const message = point?.message;

    // Первую причину по полю оставляем: следующая обычно её же и повторяет.
    if (typeof field === "string" && typeof message === "string" && !byField[field]) {
      byField[field] = message;
    }
  }

  return byField;
}

/** Общее сообщение отказа: `message` ответа, иначе `error`, иначе запасное. */
export function errorMessageFrom(error: unknown, fallback: string): string {
  const data = (error as any)?.response?.data;

  return data?.message || data?.error || (error as any)?.message || fallback;
}
